import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";

type ClonePageAsync = (payload: {
  accessToken: string;
  subdomain: string;
  pageUrl: string;
}) => Promise<AxiosResponse<any>>;

export const clonePageAsync: ClonePageAsync = ({
  accessToken,
  subdomain,
  pageUrl,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${api.websitePages.cloneWebsitePage.prefix}${subdomain}/${pageUrl}${api.websitePages.cloneWebsitePage.postfix}`;
    axios
      .post(apiUrl, {}, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
